import { dayShort, daysUntil, isIsoDate } from '../format/dates'
import type { Product } from '../types/catalog'

export type ActivePromo = { label: string; until: string | null }

/**
 * De actie op een product, zoals de klant hem mag zien.
 * - Een verlopen actie (einddatum in het verleden) telt niet meer: geen "Actie" op een kaart die al voorbij is.
 * - Een ISO-datum wordt "t/m 31 okt"; vrije tekst uit WooCommerce blijft staan; leeg = geen einddatum tonen.
 */
export function activePromo(product: Product): ActivePromo | null {
  const promo = product.promo
  if (!promo?.label.trim()) return null
  const end = promo.endsOn.trim()
  if (isIsoDate(end)) return daysUntil(end) < 0 ? null : { label: promo.label, until: `t/m ${dayShort(end)}` }
  return { label: promo.label, until: end || null }
}
